import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  InputLabel,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { useDeleteEventHistoryMutation, useOfferedCandidatesMutation, useViewCandidateHistoryMutation } from "../../redux/candidateprofiles/candidateprofiles.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import CloseIcon from "@mui/icons-material/Close";
import { CalendarIcon } from "lucide-react";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import MUIButton from "../../reusable_components/components/MUIButton";
import { History } from "@mui/icons-material";

const OfferedCandidate = ({ search }) => {
  const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));
  const { Snackbar } = useContext(SnackbarContext);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [triggerApi, setTriggerApi] = useState(false);
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [open, setOpen] = useState(false);
  const [candidateHistory, setCandiateHistory] = useState([]);
  const [historytableLoder, setHistorytableLoder] = useState(false);
  const [MinihistoryDialogOpen, setMinihistoryDialogOpen] = useState(false);
  const [profileMatchId, setProfileMatchId] = useState();
  const [deleteId, setDeleteId] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  const [page, setPage] = useState(
    +localStorage.getItem("offeredCandidateSearch") || 1
  );

  const [fromDate, setFromDate] = useState(
    commonFilter?.candidateProfiles?.fromDate
      ? dayjs(commonFilter?.candidateProfiles?.fromDate)
      : null
  );
  const [toDate, setToDate] = useState(
    commonFilter?.candidateProfiles?.toDate
      ? dayjs(commonFilter?.candidateProfiles?.toDate)
      : null
  );
  const [sourcedBy, setSourcedBy] = useState(
    commonFilter?.candidateProfiles?.sourcedBy || ""
  );
  const navigate = useNavigate();

  const [offeredData] = useOfferedCandidatesMutation();
  const [viewcandidateHistory] = useViewCandidateHistoryMutation();
  const [deleteHistory] = useDeleteEventHistoryMutation();

  const [offeredDatas, setOfferedDatas] = useState([]);
  const [counts, setCounts] = useState(0);
  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  const isExternal = Profile?.profile?.isExternalRecruiter;

  const offeredTableDatas = async () => {
    try {
      const payload = {
        page: page ? page - 1 : 0,
        size: rowsPerPage ? rowsPerPage : 10,
        candidateSearch: search,
        sourceBy: sourcedBy,
        fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : null,
      };
      setShowTableLoader(true);
      const response = await offeredData(payload).unwrap();
      setShowTableLoader(false);
      setOfferedDatas(response?.response?.data);
      setCounts(response?.response?.totalItems);
      setIsPrevious(false)
    } catch (error) {
      Snackbar("Network failed", "error");
      setShowTableLoader(false);
    }
  };

  useEffect(() => {
    if (search && !isPrevious) {
      if (page > 1) {
        setPage(1)
        localStorage.setItem("offeredCandidateSearch", 1);
      }
    }
    offeredTableDatas();
  }, [search]);

  useEffect(() => {
    offeredTableDatas();
    setTriggerApi(false);
  }, [rowsPerPage, page, triggerApi]);

  // useEffect(() => {
  //   offeredTableDatas();
  // }, []);

  useEffect(() => {
    if (shouldFetch) {
      letsFilterDatas()
      setShouldFetch(false);
      setTriggerApi(true);
      setFilterDialogOpen(false);
    }
  }, [shouldFetch]);

  const handleChangePage = (event, newPage) => {
    localStorage.setItem("offeredCandidateSearch", newPage);
    setPage(newPage);
  };

  const [isPrevious, setIsPrevious] = useState(true)
  const handleCandidateNav = (item) => {
    navigate(`/candidate-view/${item?.profileId}`, {
      state: { offer: true },
    });
    setIsPrevious(true)
  };

  const [showClearFilter, setShowClearFilter] = useState(false);
  const handleOpenFillterDialog = () => {
    setFilterDialogOpen(true);
  };

  const handleclearFilterState = () => {
    setFromDate(null);
    setToDate(null);
    setSourcedBy("");
    setTriggerApi(true);
    setShowClearFilter(false);
    localStorage.setItem(
      "commonsearchfilter",
      JSON.stringify({ ...commonFilter, candidateProfiles: {} })
    );
  };

  const hanldeFromDate = (value) => {
    if (toDate && toDate <= value) {
      setToDate(null);
    }
    setFromDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        fromDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleTodate = (value) => {
    setToDate(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        toDate: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const getNextDay = (fromDate) => {
    if (!fromDate) {
      return null;
    }
    return dayjs(fromDate)?.add(1, "day");
  };

  const handleSourcedBy = (e) => {
    setSourcedBy(e.target.value);
    const value = e.target.value;

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      candidateProfiles: {
        ...currentFilter.candidateProfiles,
        sourcedBy: value,
      },
    };

    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const [chips, setChips] = useState([]);

  const letsFilterDatas = () => {
    const updateChip = [
      fromDate && {
        label: fromDate ? dayjs(fromDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setFromDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                fromDate: null,
              },
            })
          );
          setTriggerApi(true);
          setToDate(null);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(fromDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      toDate && {
        label: toDate ? dayjs(toDate)?.format("DD-MM-YYYY") : "",
        onDelete: () => {
          setToDate(null);
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                toDate: null,
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter(
              (chips) => chips?.label !== dayjs(toDate)?.format("DD-MM-YYYY")
            )
          );
        },
      },
      {
        label: sourcedBy,
        onDelete: () => {
          setSourcedBy("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              candidateProfiles: {
                ...commonFilter.candidateProfiles,
                sourcedBy: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChips) =>
            prevChips?.filter((chips) => chips?.label !== sourcedBy)
          );
        },
      },
    ].filter(Boolean);

    setChips(updateChip);
    setTriggerApi(true);
    setShowClearFilter(true);
  };

  const handleCloseFilterDialog = () => {
    setFilterDialogOpen(false);
    const hasValue = chips?.some((item) => item?.label);

    if (!hasValue) {
      setSourcedBy("");
      setFromDate(null);
      setToDate(null);
      localStorage.setItem(
        "commonsearchfilter",
        JSON.stringify({ ...commonFilter, candidateProfiles: {} })
      );
    }
  };

  useEffect(() => {
    const candidateProfiles = commonFilter?.candidateProfiles;
    const hasValue =
      candidateProfiles &&
      Object.values(candidateProfiles)?.some(
        (value) =>
          value !== 0 && value !== null && value !== undefined && value !== ""
      );

    if (hasValue) {
      setShouldFetch(true);
    }
  }, []);

  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleClose = () => {
    setOpen(false);
    setHistorytableLoder(false);
    setCandiateHistory(false)
  };

  const hanldeMiniDialogOpen = (item) => {
    setMinihistoryDialogOpen(true);
    setProfileMatchId(item?.profileMatchId);
    setDeleteId(item?.eventHistoryId);
    setIsDelete(item?.deletable);
  };

  const viewHistory = async (profileId) => {
    setOpen(true);
    try {
      const payload = {
        profileId: profileId,
        positionId: 0,
        page: page - 1,
        size: 5000,
      };
      const response = await viewcandidateHistory(payload)?.unwrap();
      if (response) {
        setCandiateHistory(response?.response?.eventHistory);
        setHistorytableLoder(true);
      }
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const deleteEventHistory = async (item) => {
    if (isDelete === true) {
      try {
        const payload = {
          eventHistoryIds: [deleteId] || [],
          profileMatchId: profileMatchId, // Use 0 as default if profileMatchId is missing
        };

        const response = await deleteHistory(payload).unwrap();
        setMinihistoryDialogOpen(false);
        setOpen(false);

        Snackbar(response?.response?.message, "success");
      } catch (error) {
        Snackbar("Network error", "error");
      }
    } else {
      Snackbar("Network error", "error");
    }
  };

  return (
    <Box>
      <Paper
        sx={{
          width: "100%",
          overflow: "auto",
          marginTop: "10px",
          border: "1px solid #E9EAEB",
          borderRadius: "10px",
        }}
        elevation={0}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={100} sx={{ padding: "5px" }}>
                <Box
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    {showClearFilter &&
                      chips?.map(
                        (chip, index) =>
                          chip?.label && (
                            <Chip
                              variant="outlined"
                              size="small"
                              className="Chip"
                              key={index}
                              label={chip?.label}
                              deleteIcon={
                                <CloseIcon
                                  sx={{ color: "#414651 !important" }}
                                />
                              }
                              onDelete={chip?.onDelete}
                            />
                          )
                      )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "14px",
                    }}
                  >
                    <MUICancelButton
                      title="More Filters"
                      onClick={handleOpenFillterDialog}
                      startIcon={
                        <FilterListOutlinedIcon
                          sx={{ fontSize: "14px !important" }}
                        />
                      }
                      sx={{
                        color: "#6941C6",
                        borderColor: "#D6BBFB",
                        fontWeight: 600,
                        width: "130px",
                      }}
                    />
                    {(fromDate ||
                      toDate ||
                      sourcedBy) &&
                      showClearFilter && (
                        <MUICancelButton
                          title="Clear filter"
                          onClick={handleclearFilterState}
                          sx={{ width: "100px" }}
                        />
                      )}
                  </div>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="tableHeadersCell_2">Name</TableCell>
              <TableCell className="tableHeadersCell_2">Email</TableCell>
              <TableCell className="tableHeadersCell_2">
                Position Name
              </TableCell>
              <TableCell className="tableHeadersCell_2">Client Name</TableCell>
              <TableCell className="tableHeadersCell_2">Sourced By</TableCell>
              <TableCell className="tableHeadersCell_2">Offered date</TableCell>
              <TableCell className="tableHeadersCell_2">Tentative joining date</TableCell>
              <TableCell className="tableHeadersCell_2">History </TableCell>
            </TableRow>
          </TableHead>
          {!showTableLoader ? (
            offeredDatas.length > 0 ? (
              <TableBody>
                {offeredDatas.map((item, index) => (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={item.code}
                    sx={{
                      backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                      "&:hover": { backgroundColor: "#f1f1f1" },
                    }}
                  >
                    <TableCell
                      className="tableBodyCells"
                      onClick={() => handleCandidateNav(item)}
                      sx={{ cursor: "pointer" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <Typography className="tableBodyCells">
                          <span
                            style={{
                              color: "#53389E",
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                          >
                            {item?.profileName}
                          </span>
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.emailId}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.positionName}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.clientName}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      <span style={{
                        color: "#53389E",
                        fontWeight: 600,
                        fontSize: "12px",
                      }}>{item?.sourceBy}</span>
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.eventDate == "NA"
                        ? "NA"
                        : dayjs(item?.eventDate).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell className="tableBodyCells">
                      {item?.tentativeDate == "NA"
                        ? "-"
                        : dayjs(item?.tentativeDate).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell
                      className="tableBodyCells"
                      sx={{ color: "#181D27" }}
                    >
                      <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', gap: 0.5 }} onClick={() => viewHistory(item?.profileId)}>
                        <History sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                        <span style={{ fontSize: '12px', color: '#6941C6', fontWeight: 'bold' }} >View</span>
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography className="emptydatas">
                      No Data Found
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            )
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <Box className="tableloader">
                  <TableLoader />
                </Box>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            {counts <= rowsPerPage ? null : (
              <TableCell colSpan={10}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MUICancelButton
                    title="Previous"
                    startIcon={
                      <ArrowBackIcon
                        sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                      />
                    }
                    disabled={page === 1}
                    onClick={() => setPage((page) => page - 1)}
                    sx={{ height: "36px" }}
                  />
                  <Pagination
                    page={page}
                    onChange={handleChangePage}
                    count={Math.ceil(counts / rowsPerPage)}
                    siblingCount={3}
                    boundaryCount={3}
                    shape="rounded"
                    hidePrevButton
                    hideNextButton
                  />
                  <MUICancelButton
                    title="Next"
                    endIcon={
                      <ArrowForwardIcon
                        sx={{
                          color:
                            page === Math.ceil(counts / rowsPerPage)
                              ? "#a2a2a2"
                              : "#414651",
                        }}
                      />
                    }
                    disabled={page === Math.ceil(counts / rowsPerPage)}
                    onClick={() => setPage((page) => page + 1)}
                    sx={{ height: "36px" }}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        </Table>
      </Paper>

      <Grid2 item>
        <Dialog
          open={filterDialogOpen}
          scroll="paper"
          maxWidth="md"
          className="sidePopup"
        >
          <DialogTitle
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Filters
            </Typography>
            <CloseIcon
              onClick={() => setFilterDialogOpen(false)}
              sx={{ cursor: "pointer" }}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid2
                container
                rowGap={2}
                sx={{ display: "flex", width: "100%" }}
              >

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">From Date</InputLabel>
                  <MuiDatePicker
                    value={fromDate}
                    onChange={hanldeFromDate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By From Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                  />
                </Box>
                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input">To Date</InputLabel>
                  <MuiDatePicker
                    value={toDate}
                    onChange={handleTodate}
                    slots={{
                      openPickerIcon: CalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        placeholder: "Choose By To Date",
                        InputProps: {
                          sx: { borderRadius: "10px", height: "35px" },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                    format="DD-MM-YYYY"
                    minDate={getNextDay(fromDate) || null}
                    maxDtae={dayjs()}
                    disabled={!fromDate}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  <InputLabel className="input"> Sourced By </InputLabel>
                  <TextField
                    className="textfields"
                    size="small"
                    placeholder=" Search Sourced By"
                    value={sourcedBy || ""}
                    onChange={handleSourcedBy}
                  />
                </Box>
              </Grid2>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid2
              item
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              <MUICancelButton
                title="Cancel"
                sx={{ width: "42%" }}
                onClick={handleCloseFilterDialog}
              />
              <MUIButton
                title="Apply"
                sx={{ width: "42%" }}
                onClick={() => {
                  setPage(1);
                  setShouldFetch(true);
                }}
              />
            </Grid2>
          </DialogActions>
        </Dialog>

        <Grid2 item>
          <Dialog
            open={MinihistoryDialogOpen}
            scroll="paper"
            maxWidth="xs"
            sx={{
              "& .MuiDialog-paper": {
                width: "90%",
                maxWidth: "550px",
                height: "auto",
                borderRadius: "15px",
              },
            }}
          >
            <DialogContent>
              <DialogContentText>
                <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
                  <div
                    style={{
                      backgroundColor: "#FEE4E2",
                      borderRadius: "40px",
                      height: "40px",
                      width: "45px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <DeleteIcon stroke={"red"} />
                  </div>

                  <div>
                    <Typography
                      sx={{
                        color: "#181D27",
                        fontWeight: 600,
                        fontSize: "17px",
                      }}
                    >
                      Delete History?
                    </Typography>
                    <Typography
                      sx={{
                        color: "#535862",
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Are you sure you want to delete this history? This action
                      cannot be undone.
                    </Typography>
                  </div>
                </div>
                <Grid2
                  item
                  sx={{
                    marginTop: "25px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                  }}
                >
                  <MUICancelButton
                    title="Cancel"
                    onClick={() => setMinihistoryDialogOpen(false)}
                  />
                  <MUIButton
                    title="Delete"
                    sx={{
                      backgroundColor: "#D92D20",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={deleteEventHistory}
                  />
                </Grid2>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Grid2>
      </Grid2>

      <Grid2>
        <Dialog
          open={open}
          onClose={handleClose}
          scroll="paper"
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              minHeight: "85vh",
              minWidth: "70vw",
            },
            marginLeft: "70px",
          }}
        >
          <DialogTitle variant="h6">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                History
              </Typography>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={handleClose}
              ></CloseIcon>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="tableHeadersCell">Date </TableCell>
                    <TableCell className="tableHeadersCell">
                      Client Name{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">
                      Job Title{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Event </TableCell>
                    <TableCell className="tableHeadersCell">Notes </TableCell>
                    <TableCell className="tableHeadersCell">
                      Processed By{" "}
                    </TableCell>
                    <TableCell className="tableHeadersCell">Action</TableCell>
                  </TableRow>
                </TableHead>
                {historytableLoder ? (
                  candidateHistory.length > 0 ? (
                    <TableBody>
                      {candidateHistory.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {formatDate(item.date)}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.clientName}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.jobTitile}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.event}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item.notes}
                          </TableCell>

                          <TableCell className="tableBodyCell">
                            {item.processedBy}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            <Tooltip
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                  },
                                },
                              }}
                              title={item?.deletable ? "Delete" : ""}
                            >
                              <IconButton
                                sx={{ color: item?.deletable && "#fd5c63" }}
                                disabled={!item?.deletable}
                                onClick={(e) =>
                                  item?.deletable && hanldeMiniDialogOpen(item)
                                }
                              >
                                <DeleteIcon
                                  stroke={item?.deletable ? "red" : "#a2a2a2"}
                                  style={{
                                    cursor: !item?.deletable && "not-allowed",
                                    pointerEvents: "auto",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={10}>
                          <Typography className="emptydatas">
                            No Data Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )
                ) : (
                  <TableCell colSpan={100}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                )}
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <MUICancelButton onClick={handleClose} title="Close">
              Close
            </MUICancelButton>
          </DialogActions>
        </Dialog>
      </Grid2>
    </Box>
  );
};

export default OfferedCandidate;
